import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DropdownItem extends Component {
	shouldComponentUpdate(nextProps) {
		if (nextProps.selected === this.props.selected) {
			return false;	
		}
		return true;
	}

	render() {
		const { title, selected, toggleItem } = this.props;
		
		return (
			<li className="drop-down__item">
				<label>
					<input type="checkbox" checked={selected} onChange={() => toggleItem(!selected)}/>
					<span>{title}</span>
				</label>
			</li>
		);
	}
}

DropdownItem.propTypes = {
	title: PropTypes.string.isRequired,
	selected: PropTypes.bool.isRequired,
	toggleItem: PropTypes.func.isRequired,
}

export default DropdownItem;


// WEBPACK FOOTER //
// ./src/components/common/files/filters/Dropdown/DropdownItem.js